import React, {useEffect} from 'react';
import '../styles/Portfolio.css'; // You can create this file for specific styling

const Portfolio = () => {
    useEffect(() => {
        document.title = 'Portfolio | Bularis Tech';
      }, []);
      
  return (
    <div className="portfolio">
      <div className="portfolio-header">
        <h1>Our Portfolio</h1>
        <p>Explore our past projects and see the work we've done for clients.</p>
      </div>
      <div className="portfolio-gallery">
        <div className="portfolio-item">
          <img src="https://via.placeholder.com/300" alt="Project 1" />
          <h3>Project Title 1</h3>
          <p>Description of the project or work done.</p>
        </div>
        <div className="portfolio-item">
          <img src="https://via.placeholder.com/300" alt="Project 2" />
          <h3>Project Title 2</h3>
          <p>Description of the project or work done.</p>
        </div>
        <div className="portfolio-item">
          <img src="https://via.placeholder.com/300" alt="Project 3" />
          <h3>Project Title 3</h3>
          <p>Description of the project or work done.</p>
        </div>
        <div className="portfolio-item">
          <img src="https://via.placeholder.com/300" alt="Project 4" />
          <h3>Project Title 4</h3>
          <p>Description of the project or work done.</p>
        </div>
      </div>
    </div>
  );
}

export default Portfolio;
